export var METADATA_KEY = {
    DESIGN_PARAM_TYPES: 'design:paramtypes',
    PARAM_TYPES: 'wikia-ioc:paramtypes',
    TAGGED_TYPES: 'wikia-ioc:taggedtypes',
    AUTOBIND: 'wikia-ioc:autobind',
    SCOPE: 'wikia-ioc:scope',
};
//# sourceMappingURL=metadata-keys.js.map